import { render, staticRenderFns } from "./controlRoomLightning.vue?vue&type=template&id=849a462c&scoped=true&"
import script from "./controlRoomLightning.vue?vue&type=script&lang=js&"
export * from "./controlRoomLightning.vue?vue&type=script&lang=js&"
import style0 from "./controlRoomLightning.vue?vue&type=style&index=0&id=849a462c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849a462c",
  null
  
)

export default component.exports